module.exports = __webpack_public_path__ + "static/media/reference-icon-green.69b92155.svg";